const imprintContent = {
  de: {
    langLabel: "IMPRESSUM",
    title: "Impressum",
    intro: "Angaben gemäß § 5 DDG und rechtliche Informationen zu ALGermanist.",
    sections: [
      {
        title: "Angaben gemäß § 5 DDG",
        body: [
          "ALGermanist\nInhaber: Mafdi Garas\nSchottenstraße\n78462 Konstanz\nDeutschland\n\nE-Mail: info@algermanist.com\nWebseite: https://algermanist.com",
        ],
      },
      {
        title: "Vertreten durch",
        body: ["Mafdi Garas"],
      },
      {
        title: "Unternehmensgegenstand",
        body: [
          "ALGermanist ist ein privater Anbieter für:",
          "Online-Deutschkurse\ninterkulturelles Training\nBewerbungscoaching\nBeratung und Unterstützung internationaler Auszubildender und Fachkräfte\nUnterstützung beim Einstieg in den deutschen Arbeitsmarkt\nVermittlungsmöglichkeiten an potenzielle Arbeitgeber und Ausbildungsbetriebe in Deutschland",
        ],
      },
      {
        title: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
        body: [
          "Mafdi Garas\nSchottenstraße\n78462 Konstanz\nDeutschland",
        ],
      },
      {
        title: "Haftung für Inhalte",
        body: [
          "Die Inhalte dieser Webseite wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr.",
        ],
      },
      {
        title: "Haftung für externe Links",
        body: [
          "Diese Webseite enthält Links zu externen Webseiten Dritter. Auf deren Inhalte haben wir keinen Einfluss. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.",
        ],
      },
      {
        title: "Urheberrecht",
        body: [
          "Alle auf dieser Webseite veröffentlichten Inhalte, Texte, Bilder, Videos, Unterrichtsmaterialien und sonstigen Materialien unterliegen dem deutschen Urheberrecht.",
          "Jede Vervielfältigung, Bearbeitung, Verbreitung, Speicherung oder Weitergabe außerhalb der gesetzlichen Grenzen bedarf der vorherigen schriftlichen Zustimmung von ALGermanist.",
        ],
      },
      {
        title: "Hinweis zur Sprache",
        body: [
          "Die deutsche Fassung dieses Impressums ist rechtlich maßgeblich. Übersetzungen dienen ausschließlich der besseren Verständlichkeit.",
        ],
      },
    ],
  },
  en: {
    langLabel: "IMPRINT",
    title: "Imprint",
    intro: "Legal information according to § 5 DDG and general provider information for ALGermanist.",
    sections: [
      {
        title: "Information According to § 5 DDG",
        body: [
          "ALGermanist\nOwner: Mafdi Garas\nSchottenstraße\n78462 Konstanz\nGermany\n\nEmail: info@algermanist.com\nWebsite: https://algermanist.com",
        ],
      },
      {
        title: "Represented By",
        body: ["Mafdi Garas"],
      },
      {
        title: "Business Purpose",
        body: [
          "ALGermanist is a private provider for:",
          "Online German courses\nintercultural training\napplication coaching\nconsulting and support for international trainees and skilled workers\nsupport for entering the German labor market\npossible placement opportunities with potential employers and training companies in Germany",
        ],
      },
      {
        title: "Responsible for Content According to § 18 Para. 2 MStV",
        body: [
          "Mafdi Garas\nSchottenstraße\n78462 Konstanz\nGermany",
        ],
      },
      {
        title: "Liability for Content",
        body: [
          "The contents of this website have been created with the greatest possible care. However, we do not guarantee the accuracy, completeness, or timeliness of the content.",
        ],
      },
      {
        title: "Liability for External Links",
        body: [
          "This website contains links to external third-party websites. We have no influence over their content. The respective provider or operator of the linked pages is always responsible for their content.",
        ],
      },
      {
        title: "Copyright",
        body: [
          "All content, texts, images, videos, teaching materials, and other materials published on this website are subject to German copyright law.",
          "Any reproduction, editing, distribution, storage, or forwarding beyond the limits permitted by law requires prior written consent from ALGermanist.",
        ],
      },
      {
        title: "Language Notice",
        body: [
          "The German version of this imprint is legally authoritative. Translations are provided solely for better understanding.",
        ],
      },
    ],
  },
  ar: {
    langLabel: "البيانات القانونية للموقع",
    title: "البيانات القانونية للموقع",
    intro: "معلومات قانونية وفقًا للمادة § 5 DDG وبيانات مزود الخدمة لموقع ALGermanist.",
    sections: [
      {
        title: "البيانات وفقًا للمادة § 5 DDG",
        body: [
          "ALGermanist\nالمالك: Mafdi Garas\nSchottenstraße\n78462 Konstanz\nDeutschland\n\nالبريد الإلكتروني: info@algermanist.com\nالموقع الإلكتروني: https://algermanist.com",
        ],
      },
      {
        title: "يمثله",
        body: ["Mafdi Garas"],
      },
      {
        title: "موضوع النشاط",
        body: [
          "ALGermanist هو مزود خاص للخدمات التالية:",
          "دورات لغة ألمانية عبر الإنترنت\nتدريب بين الثقافات\nتدريب ودعم في التقديم والطلبات\nاستشارات ودعم للمتدربين والكوادر الدولية\nدعم الدخول إلى سوق العمل الألماني\nإمكانيات وساطة مع أصحاب عمل وشركات تدريب محتملة في ألمانيا",
        ],
      },
      {
        title: "المسؤول عن المحتوى وفقًا للمادة § 18 الفقرة 2 MStV",
        body: [
          "Mafdi Garas\nSchottenstraße\n78462 Konstanz\nDeutschland",
        ],
      },
      {
        title: "المسؤولية عن المحتوى",
        body: [
          "تم إعداد محتوى هذا الموقع بأكبر قدر ممكن من العناية. ومع ذلك، لا نتحمل أي ضمان بخصوص صحة أو اكتمال أو حداثة المحتوى.",
        ],
      },
      {
        title: "المسؤولية عن الروابط الخارجية",
        body: [
          "يحتوي هذا الموقع على روابط لمواقع خارجية تابعة لأطراف ثالثة. لا نملك أي تأثير على محتواها. يتحمل مزود أو مشغل الصفحات المرتبطة المسؤولية دائمًا عن محتواها.",
        ],
      },
      {
        title: "حقوق النشر",
        body: [
          "جميع المحتويات والنصوص والصور والفيديوهات والمواد التعليمية والمواد الأخرى المنشورة على هذا الموقع تخضع لقانون حقوق النشر الألماني.",
          "أي نسخ أو تعديل أو نشر أو تخزين أو مشاركة خارج الحدود القانونية يتطلب موافقة كتابية مسبقة من ALGermanist.",
        ],
      },
      {
        title: "ملاحظة بخصوص اللغة",
        body: [
          "النسخة الألمانية من هذه البيانات القانونية هي النسخة المعتمدة قانونيًا. الترجمات مقدمة فقط لتسهيل الفهم.",
        ],
      },
    ],
  },
};

export default imprintContent;
